import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import SocialIcons from "./SocialIcons";
import { NavLinks, NavSearch, NavAuthLinks } from "./NavParts";

export default function Nav() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const navigate = useNavigate();
  const close = () => setOpen(false);

  const onSearch = (e) => {
    e.preventDefault();
    if (q.trim()) {
      navigate(`/blog?q=${encodeURIComponent(q.trim())}`);
      setQ("");
      setOpen(false);
    }
  };

  return (
    <header
      className="sticky top-0 z-50 backdrop-blur-xl border-b"
      style={{ backgroundColor: "rgba(249, 246, 241, 0.86)", borderColor: "var(--border)" }}
      data-testid="site-nav"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-24 md:h-28">
          <Link to="/" className="flex items-center" data-testid="brand-link">
            <span className="block h-24 w-24 md:h-28 md:w-28 overflow-hidden">
              <img
                src="https://customer-assets.emergentagent.com/job_tea-time-site-1/artifacts/ulxg2di4_The%20Tea%20List%20Log_New.png"
                alt="The Tea List"
                className="tea-list-logo"
              />
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-9">
            <NavLinks withTestIds />
          </nav>

          <div className="flex items-center gap-4">
            <NavSearch
              q={q}
              setQ={setQ}
              onSearch={onSearch}
              className="hidden md:flex items-center gap-2 border-b border-[#151e1a]/30 focus-within:border-[#1e4a35] transition-colors"
              inputClassName="bg-transparent outline-none text-sm py-1 w-28 focus:w-44 transition-all"
              testId="nav-search-input"
            />
            <div className="hidden md:flex items-center gap-4">
              <NavAuthLinks user={user} logout={logout} />
            </div>
            <div className="hidden md:flex pl-3 ml-1 border-l" style={{ borderColor: "var(--border)" }}>
              <SocialIcons size="sm" />
            </div>
            <button onClick={() => setOpen(!open)} className="md:hidden p-1" aria-label="Toggle menu" data-testid="nav-menu-toggle">
              {open ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>

        {open && (
          <div className="md:hidden py-6 border-t border-[#e2d9c6] flex flex-col gap-5" data-testid="nav-mobile-menu">
            <NavLinks onNavigate={close} />
            <NavSearch
              q={q}
              setQ={setQ}
              onSearch={onSearch}
              className="flex items-center gap-2 border-b border-[#151e1a]/30 pt-2"
              inputClassName="bg-transparent outline-none text-sm py-1 flex-1"
              testId="nav-mobile-search-input"
            />
            <NavAuthLinks user={user} logout={logout} onNavigate={close} mobile />
            <div className="pt-4 mt-2 border-t" style={{ borderColor: "var(--border)" }}>
              <p className="font-mono text-[9px] uppercase tracking-widest text-[#66726d] mb-3">Follow</p>
              <SocialIcons size="md" showHandles />
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
